module.exports = __webpack_public_path__ + "img/dick3-cover-2.4afe3bab.jpg";